import { useState } from "react";
import AnimateHeight from "react-animate-height";
import "./Expander.scss";

export default function Expander({
  title,
  children,
  className,
  defaultOpen,
}: {
  title?: any;
  children?: any;
  className?: any;
  defaultOpen: false;
}) {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  return (
    <div className="cs1 ce12">
      <div className="grid  cursor-pointer" onClick={() => setOpen(!open)}>
        <div
          style={{
            cursor: "pointer",
            marginBottom: "var(--grid-gap)",
          }}
          className={
            "cs1 icon m2 mt-0 mb-0 icon-arrow-right expander-icon" +
            (open && " expander-open")
          }></div>
        {title}
      </div>
      <AnimateHeight
        duration={1000}
        height={open ? "auto" : 0}
        easing="cubic-bezier(0, 1, 0.5, 1)">
        {children}
      </AnimateHeight>
    </div>
  );
}
